import "./style.scss";

const LoaderImg = () => {
	return <div class="loaderImg"></div>;
};
export default LoaderImg;
